// 洞洞杂货铺 · 设定百科数据
export interface SettingEntry {
  id: string;
  category: string;
  title: string;
  summary: string;
  points: string[];
  image: string;
}

export const settingCategories: string[] = ["店铺设定", "洞洞法则", "隐藏线索"];

export const settingEntries: SettingEntry[] = [
  {
    id: "shop-space",
    category: "店铺设定",
    title: "无限深处的货架",
    summary:
      "杂货铺从外面看只是一间普通的小店，内部却远比表面深远。货架与货架之间，藏着普通顾客看不见的通道与夹层。",
    points: [
      "每七排货架后会出现一个标着「非卖品」的暗门",
      "店内面积会随进入者的心情而改变",
      "打烊后的店，比白天多出三层楼",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20magical%20grocery%20store%20shelves%20with%20hidden%20doorways%20and%20endless%20corridors%2C%20amber%20and%20cream%20palette%2C%20storybook%20fantasy%20style%2C%20hand%20drawn%20cozy%20mystery&width=700&height=460&seq=setting-shop-1&orientation=landscape",
  },
  {
    id: "dongdong-rule",
    category: "洞洞法则",
    title: "洞洞的三大法则",
    summary:
      "杂货铺里的洞洞并非随意出现，它们遵循着三条被店主默默遵守的古老法则，也是理解整部世界观的关键。",
    points: [
      "法则一：洞洞只开在「需要」的地方",
      "法则二：走进洞洞的人，会忘记一小段记忆作交换",
      "法则三：同一只猫永远可以自由往返，不受法则约束",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20glowing%20circular%20magical%20holes%20of%20various%20sizes%20in%20a%20cozy%20room%2C%20sparkles%20and%20soft%20light%2C%20amber%20teal%20cream%20palette%2C%20storybook%20fantasy%20style%2C%20hand%20drawn&width=700&height=460&seq=setting-rule-2&orientation=landscape",
  },
  {
    id: "glass-bottle",
    category: "隐藏线索",
    title: "反复出现的绿色玻璃瓶",
    summary:
      "每隔三话就会在画面角落出现一次的同款绿色玻璃瓶，是粉丝考据界公认的核心伏笔，可能与洞洞的真正来源有关。",
    points: [
      "瓶身标签上的数字总在悄悄变化",
      "每个持有过瓶子的人都做过同样的梦",
      "最新一话里，瓶子出现在店主的手里",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20old%20green%20glass%20bottle%20on%20a%20wooden%20grocery%20shelf%20with%20soft%20glow%2C%20mystery%20vintage%20atmosphere%2C%20amber%20teal%20cream%20palette%2C%20storybook%20style%2C%20hand%20drawn%20close%20up&width=700&height=460&seq=setting-bottle-3&orientation=landscape",
  },
];